import React from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

type ModalProps = {
  titleText: string;
  show: boolean;
  onClose: () => void;
  children?: React.ReactNode;
};

export default function InfoModal({
  show,
  titleText,
  onClose,
  children,
}: ModalProps) {
  const { t } = useTranslation();
  return (
    <Modal show={show} animation={false} onHide={onClose} backdrop="static">
      <Modal.Header>
        <button type="button" className="icon-btn" onClick={onClose}>
          <i className="icon fas fa-times fa-lg"></i>
        </button>
        <h3 className="modal-title">{titleText}</h3>
      </Modal.Header>

      <div className="modal-spacer"></div>

      <Modal.Body>{children}</Modal.Body>

      <div className="modal-spacer"></div>

      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={onClose}>
          {t('common.button.ok')}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
